import { MouseEvent } from 'react';
import { RouteType } from '@client/routes/components/Router/routes';
import { useOpenLink, useUrlCreator } from '@client/routes/hooks';

export type UseRouteLinkReturnType = {
  handleClick: (params?: Record<string, any>) => OnAnchorClickType;
  href: (params?: Record<string, any>) => string;
};

export const useRouteLink = (route: RouteType): UseRouteLinkReturnType => {
  const openLink = useOpenLink();
  const urlCreator = useUrlCreator();

  const href = (params?: Record<string, any>) => urlCreator(route, params);

  const handleClick = (params?: Record<string, any>): OnAnchorClickType => (
    e: MouseEvent<HTMLAnchorElement>,
  ): void => {
    e.preventDefault();
    openLink(e, href(params));
  };

  return {
    handleClick,
    href,
  };
};
